import * as Yup from 'yup';

export const clawMachinePrizeSchema = Yup.object({
  title: Yup.string().required('El título es requerido'),
  description: Yup.string().optional(),
  imageUrl: Yup.string().optional(),
  rewardType: Yup.string().required('El tipo de recompensa es requerido'),
  rewardableType: Yup.string().optional(),
  rewardableId: Yup.string().optional().nullable(),
  extra_data: Yup.object().when('rewardType', {
    is: 'store_discount',
    then: (schema) => schema.shape({
      limit: Yup.number().positive('El límite debe ser un número positivo').required('El límite es requerido para cupones de descuento')
    }),
    otherwise: (schema) => schema.optional()
  })
});

export type ClawMachinePrizeFormData = {
  title: string;
  description?: string;
  imageUrl?: string;
  rewardType: 'xp' | 'treasure_chance' | 'claw_coin' | 'token' | 'blockchain_token' | 'store_product' | 'store_discount' | 'physical_item';
  rewardableType?: string;
  rewardableId?: string;
  extra_data?: {
    limit?: number;
    [key: string]: any;
  };
};